import { InTransitMapPort } from '@fareye/intransit-map'
import {
  FaBell,
  FaChartLine,
  FaCog,
  FaDollyFlatbed,
  FaFilePdf,
  FaHome,
  FaList,
  FaRoute,
  FaSearchLocation,
  FaTachometerAlt,
  FaTimesCircle,
  FaTruckLoading,
  MdFlag,
  TiLocationArrowOutline
} from '@fareye/utils'
import React, { ReactNode } from 'react'
import lazy from '../utility/lazy'
import OceanAlertsRenderingConfig from './LayoutRenderingConfig/OceanAlertsRenderingConfig'
import { ChildFilterRenderingConfig } from './LayoutRenderingConfig/ChildFilterRenderingConfig'
import { ConsignerOnboardRenderingConfig } from './LayoutRenderingConfig/ConsignerOnboardRenderingConfig'
import { Profile } from '../modules/User'
import TripDetailsRenderingConfig from './LayoutRenderingConfig/TripDetailsRenderingConfig'
import Dashboard from '../modules/Dashboard'
import {SailingSchedules, GpsDashboard } from '@fareye/intransit'
import OceanKpi from '../modules/Kpi/containers/OceanGraphRenderer'
import {
  MultiModalDashboardMapper,
  ParcelDashboardMapper
} from '@fareye/kpi-dashboard'
import versions from './npmVersions'
import { formatters } from '@fareye/reports'
// import { Devices } from '@fareye/settings'
import { DashBoardRenderingConfig } from './LayoutRenderingConfig/DashboardRenderingConfig'
import ParcelAlertRenderingConfig from './LayoutRenderingConfig/ParcelAlertRenderingConfig'
import { ParcelKpiRenderingConfig } from './LayoutRenderingConfig/ParcelKpiRenderingConfig'

import {
  LayoutWithoutType,
  MultiModalDetailLayout,
  MultiModalLayout
} from '@fareye/intransit'
import { parcelConfig } from './LayoutRenderingConfig/ParcelDetailRenderingConfig'
import InTransitMapPortRenderingConfig from './LayoutRenderingConfig/InTransitMapPortRenderingConfig'
import { PoiConfig,DefaultPoiConfig, ChildUsers } from '@fareye/settings'
const TripDetails = lazy(() => import('@fareye/trip-details'), 'TripDetails')
const Devices = lazy(
  () => import('@fareye/settings'),
  'Devices'
)
const ManualTripClosure = lazy(
  () => import('@fareye/settings'),
  'ManualTripClosure'
)

const GraphConfigEditor = React.lazy(() =>
  import('../modules/Kpi/containers/GraphConfigEditor')
)
const Kpi = React.lazy(() => import('../modules/Kpi/containers/GraphRenderer'))
const IndentDashboard = React.lazy(() =>
  import('../modules/Kpi/containers/IndentGraphRenderor')
)

const TripDetailMapper = lazy(
  () => import('@fareye/trip-details'),
  'TripDetailMapper'
)
const AllocationMapper = lazy(
  () => import('@fareye/allocation'),
  'AllocationMapper'
)
const HoldOrdersMapper = lazy(
  () => import('@fareye/allocation'),
  'HoldOrdersMapper'
)
const GroupedOrdersMapper = lazy(
  () => import('@fareye/allocation'),
  'GroupedOrdersMapper'
)
const IdealRoutesMapper = lazy(
  () => import('@fareye/ideal-routes'),
  'IdealRoutesMapper'
)
const IdealRoutesMXMapper = lazy(
  () => import('@fareye/ideal-routes'),
  'IdealRoutesMXMapper'
)
const IndentMapper = lazy(() => import('@fareye/indent'), 'IndentMapper')
const VehicleListMapper = lazy(
  () => import('@fareye/indent'),
  'VehicleListMapper'
)
const InPlantMapper = lazy(() => import('@fareye/inplant'), 'InPlantMapper')
const InPlantMapMapper = lazy(
  () => import('@fareye/inplant-map'),
  'InPlantMapMapper'
)
const InTransitMapOceanMapper = lazy(
  () => import('@fareye/intransit-map'),
  'InTransitMapOceanMapper'
)
const IntransitPortMapper = lazy(
  () => import('@fareye/intransit-map'),
  'IntransitPortMapper'
)

const IntransitMapper = lazy(
  () => import('@fareye/intransit'),
  'IntransitMapper'
)
const MultiModalDetailLayoutMapper = lazy(
  () => import('@fareye/intransit'),
  'MultiModalDetailLayoutMapper'
)

const MultiModalListingMapper = lazy(
  () => import('@fareye/intransit'),
  'MultiModalListingMapper'
)

const TerminalViewMapper = lazy(
  () => import('@fareye/intransit'),
  'TerminalViewMapper'
)
const MultiModalLayoutMapper = lazy(
  () => import('@fareye/intransit'),
  'MultiModalLayoutMapper'
)
const LayoutWithoutTypeMapper = lazy(
  () => import('@fareye/intransit'),
  'LayoutWithoutTypeMapper'
)
const ETAMapper = lazy(() => import('@fareye/intransit'), 'ETAMapper')
const IntransitMapMapper = lazy(
  () => import('@fareye/intransit-map'),
  'IntransitMapMapper'
)
const NearByMapper = lazy(() => import('@fareye/nearby'), 'NearByMapper')

const POIMapper = lazy(() => import('@fareye/poi'), 'POIMapper')
const ReportSettings = lazy(() => import('@fareye/reports'), 'ReportMapper')

const StoppageAnalysisMapper = lazy(
  () => import('@fareye/stoppage-analysis'),
  'StoppageAnalysisMapper'
)
const PublicTerminalView = lazy(
  () => import('@fareye/intransit'),
  'PublicTerminalView'
)
const HubsMapper = lazy(() => import('@fareye/intransit'), 'HubsMapper')
const MultiModelHistoryMapper = lazy(
  () => import('@fareye/trip-details'),
  'MultiModelHistoryMapper'
)
const MultiModelHistory = lazy(
  () => import('@fareye/trip-details'),
  'MultiModelHistory'
)
const AlertSettingsMapper = lazy(
  () => import('@fareye/settings'),
  'AlertSettingsMapper'
)
const ChildUserFilter = lazy(
  () => import('@fareye/settings'),
  'ChildUserFilter'
)
const Settings = lazy(() => import('@fareye/settings'), 'Settings')
const RouteAndMenu = lazy(() => import('@fareye/settings'), 'RouteAndMenu')
const AlertReportMapper = lazy(
  () => import('@fareye/settings'),
  'AlertReportMapper'
)
const ParcelListingMapper = lazy(
  () => import('@fareye/intransit'),
  'ParcelListingMapper'
)

const ParcelDetailsMapper = lazy(
  () => import('@fareye/trip-details'),
  'ParcelDetailsMapper'
)
const ParcelDetails = lazy(
  () => import('@fareye/trip-details'),
  'ParcelDetails'
)
const ContainerStatusListingMapper = lazy(
  () => import('@fareye/intransit'),
  'ContainerStatusListingMapper'
)

const MultiModalOpsDashboardMapper = lazy(
  () => import('@fareye/intransit'),
  'MultiModalOpsDashboardMapper'
)

export interface IMapComponents {
  [key: string]: {
    component: ReactNode
    icon: any
    config: any
    packageName: string
  }
}

export const mappingComponents: IMapComponents = {
  kpi: {
    component: Kpi,
    config: {},
    icon: FaChartLine,
    packageName: '@fareye/kpi'
  },
  kpiConfigure: {
    component: GraphConfigEditor,
    config: {},
    icon: FaTachometerAlt,
    packageName: '@fareye/kpi'
  },
  inplantPerformance: {
    component: InPlantMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/inplant'
  },
  inplantMap: {
    component: InPlantMapMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/inplant-map'
  },
  inPlantTripDetails: {
    component: TripDetailMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  inplantDetails: {
    component: InPlantMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/inplant'
  },
  inplantTripDetailsShare: {
    component: TripDetails,
    config: TripDetailsRenderingConfig.inPlantShare,
    icon: undefined,
    packageName: '@fareye/trip-details'
  },

  inplant: {
    component: undefined,
    config: {},
    icon: FaTruckLoading,
    packageName: '@fareye/inplant'
  },
  intransitPerformance: {
    component: IntransitMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  routePerformance: {
    component: MultiModalLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  transporterPerformance: {
    component: LayoutWithoutTypeMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  intransitTransporterPerformance: {
    component: IntransitMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  transporterDetails: {
    component: IntransitMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  routeDetail: {
    component: MultiModalDetailLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  routeDetailShipment: {
    component: MultiModalDetailLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  multiModalTransporterDetail: {
    component: MultiModalDetailLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  eta: {
    component: ETAMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  intransitMap: {
    component: IntransitMapMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit-map'
  },
  intransitMapOcean: {
    component: InTransitMapOceanMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit-map'
  },
  allTrips: {
    component: IntransitMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  intransitTripDetails: {
    component: TripDetailMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  intransitRouteDetails: {
    component: IntransitMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  intransitTripDetailsShare: {
    component: TripDetails,
    config: TripDetailsRenderingConfig.inTransitShare,
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  shipmentHistoryShare: {
    component: MultiModelHistory,
    config: TripDetailsRenderingConfig.shipmentHistoryShare,
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  packageHistoryShare: {
    component: MultiModelHistory,
    config: TripDetailsRenderingConfig.packageHistoryShare,
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  intransit: {
    component: undefined,
    config: {},
    icon: TiLocationArrowOutline,
    packageName: '@fareye/intransit'
  },
  indentList: {
    component: IndentMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/indent'
  },
  indentVehicleList: {
    component: VehicleListMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/indent'
  },
  indent: {
    component: undefined,
    config: {},
    icon: FaDollyFlatbed,
    packageName: '@fareye/indent'
  },
  indentDashboard: {
    component: IndentDashboard,
    config: {},
    icon: undefined,
    packageName: '@fareye/kpi'
  },
  allocation: {
    component: undefined,
    config: {},
    icon: FaList,
    packageName: '@fareye/allocation'
  },
  allocationList: {
    component: AllocationMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/allocation'
  },
  transportersAllocated: {
    component: GroupedOrdersMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/allocation'
  },
  holdOrders: {
    component: HoldOrdersMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/allocation'
  },
  poi: {
    component: POIMapper,
    config: {},
    icon: MdFlag,
    packageName: '@fareye/poi'
  },
  nearby: {
    component: NearByMapper,
    config: {},
    icon: FaSearchLocation,
    packageName: '@fareye/nearby'
  },
  reportSettings: {
    component: ReportSettings,
    config: {},
    icon: FaFilePdf,
    packageName: '@fareye/reports'
  },
  stoppageAnalysis: {
    component: StoppageAnalysisMapper,
    config: {},
    icon: FaTimesCircle,
    packageName: '@fareye/stoppage-analysis'
  },
  settings: {
    component: Settings,
    config: {},
    icon: FaCog,
    packageName: '@fareye/settings'
  },
  alertSettings: {
    component: AlertSettingsMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  },
  alertReport: {
    component: AlertReportMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  },
  alert: {
    component: undefined,
    config: {},
    icon: FaBell,
    packageName: ''
  },
  childUserFilter: {
    component: ChildUserFilter,
    config: ChildFilterRenderingConfig,
    icon: undefined,
    packageName: '@fareye/settings'
  },
  consignerOnboarding: {
    component: ChildUserFilter,
    config: ConsignerOnboardRenderingConfig,
    icon: undefined,
    packageName: '@fareye/settings'
  },
  idealRoutes: {
    component: IdealRoutesMapper,
    config: {},
    icon: FaRoute,
    packageName: '@fareye/ideal-routes'
  },
  mxIdealRoutes: {
    component: IdealRoutesMXMapper,
    config: {},
    icon: FaRoute,
    packageName: '@fareye/ideal-routes'
  },
  overview: {
    component: Dashboard,
    config: {},
    icon: FaHome,
    packageName: '@fareye/tpt'
  },

  profile: {
    component: Profile,
    config: {},
    icon: undefined,
    packageName: '@fareye/tpt'
  },

  SailingSchedules: {
    component: SailingSchedules,
    config: {},
    icon: FaList,
    packageName: '@fareye/intransit'
  },

  GpsDashboard: {
    component: GpsDashboard,
    config: {},
    icon: FaList,
    packageName: '@fareye/intransit'
  },

  multiModelListing: {
    component: MultiModalListingMapper,
    config: {},
    icon: TiLocationArrowOutline,
    packageName: '@fareye/intransit'
  },
  multiModelListingCompleted: {
    component: MultiModalListingMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  terminalView: {
    component: TerminalViewMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  publicTerminalView: {
    component: PublicTerminalView,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  hubs: {
    component: HubsMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  journeyAllTrips: {
    component: MultiModalListingMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  containerListing: {
    component: LayoutWithoutTypeMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  packageHistory: {
    component: MultiModelHistoryMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  shipmentHistory: {
    component: MultiModelHistoryMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  container: {
    component: MultiModelHistoryMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  multiModalKpi: {
    component: MultiModalDashboardMapper,
    config: {},
    icon: FaChartLine,
    packageName: '@fareye/kpi-dashboard'
  },
  oceanStats: {
    component: OceanKpi,
    config: {},
    icon: FaChartLine,
    packageName: '@fareye/tpt'
  },
  configRouteAndMenu: {
    component: RouteAndMenu,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  },
  configManagement: {
    component: null,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  },
  reportsConfigManagement: {
    component: null,
    config: {
      columnFormatters: Object.keys(formatters),
      npmVersions: versions
    },
    icon: undefined,
    packageName: '@fareye/jsonstore-ui'
  },
  tablesConfigManagement: {
    component: null,
    config: {
      columnFormatters: Object.keys(formatters),
      npmVersions: versions
    },
    icon: undefined,
    packageName: '@fareye/jsonstore-ui'
  },
  parcel: {
    component: undefined,
    config: {},
    icon: TiLocationArrowOutline,
    packageName: '@fareye/intransit'
  },
  parcelList: {
    component: ParcelListingMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  parcelDetail: {
    component: ParcelDetailsMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  parcelDetailsShare: {
    component: ParcelDetails,
    config: parcelConfig,
    icon: undefined,
    packageName: '@fareye/trip-details'
  },
  parcelRouteDetail: {
    component: MultiModalDetailLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  parcelCarrierDetail: {
    component: MultiModalDetailLayoutMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  parcelRoutePerformance: {
    component: LayoutWithoutTypeMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  parcelCarrierPerformance: {
    component: LayoutWithoutTypeMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  parcelKpi: {
    component: ParcelDashboardMapper,
    config: {},
    icon: FaChartLine,
    packageName: '@fareye/kpi-dashboard'
  },
  portCongestionMap: {
    component: IntransitPortMapper,
    config: InTransitMapPortRenderingConfig,
    icon: FaChartLine,
    packageName: '@fareye/intransit-map'
  },
  ContainerStatusListing: {
    component: ContainerStatusListingMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  devicePortal: {
    component: Devices,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  },
  manualTripClosure: {
    component: ManualTripClosure,
    config: {},
    icon: FaTimesCircle,
    packageName: '@fareye/settings'
  },
  multiModalOpsDashboard: {
    component: MultiModalOpsDashboardMapper,
    config: {},
    icon: undefined,
    packageName: '@fareye/intransit'
  },
  poiConfig:{
    component: PoiConfig,
    config: {},
    icon:undefined,
    packageName: "@fareye/settings"
  },
  defaultpoiConfig:{
    component: DefaultPoiConfig,
    config: {},
    icon:undefined,
    packageName: "@fareye/settings"
  },
  childUsers: {
    component: ChildUsers,
    config: {},
    icon: undefined,
    packageName: '@fareye/settings'
  }
}
